var config = require('./config.json');
var Tour = require('component/tour/tour.js');

function initAnalysis(callback) {
	require.ensure(['zebra-analysis'], function (require) {
		var ZebraAnalysis = require('zebra-analysis');
		var zebraAnalysis = new ZebraAnalysis(config, 'analysis', global.AR.lang);
		zebraAnalysis.init()
			.then(function () {
				global.zebraAnalysis = zebraAnalysis;
				callback();
				var tour = new Tour(require('./tourConfig.js')());
				tour.startFirstTime();
			});
	});
}

var analysisElem = document.getElementById('analysis');
if (analysisElem) {
	initAnalysis(function () {
		global.updateTabsAccordionsSelectors();
		// $('#analysis a[href="#analysis__section-3"]').html(`<span class="tooltip">
		// 		Активы под управлением Компании
		// 		<span class="tooltip__text">
		// 			с&nbsp;учетом лизинга, аренды и&nbsp;оборудования, обслуживаемого по&nbsp;договорам
		// 		</span>
		// 	</span>`);
	});
}



/** WEBPACK FOOTER **
 ** ./frontend/components/analysis/analysis.custom.js
 **/